import {
  LayoutDashboard, TrendingUp, Receipt, LineChart, Scale, Settings,
} from '@vitness/icons';
import type { PageNavItem } from '@vitness/layouts';

/**
 * Six destinations. Scenarios is Projections' second tab — comparing saved
 * plans is a different activity from building one, but not a different
 * destination — and Sync is a Settings section, so neither needs a top-level
 * slot.
 *
 * Funding earns one. Checking whether the budget provider still holds what
 * Notion says it should is a recurring activity, not a preference; the mapping
 * that makes the comparison possible stays behind /funding/settings.
 */
export const NAV_ITEMS: PageNavItem[] = [
  { id: '/',            label: 'Dashboard',   icon: LayoutDashboard },
  { id: '/projections', label: 'Projections', icon: TrendingUp },
  { id: '/expenses',    label: 'Expenses',    icon: Receipt },
  { id: '/funding',     label: 'Funding',     icon: Scale },
  { id: '/networth',    label: 'Net Worth',   icon: LineChart },
  { id: '/settings',    label: 'Settings',    icon: Settings },
];

/**
 * The bottom bar mirrors the sidebar's main destinations. Settings is not
 * pinned by default — it lives behind "More" (and the account chip), which
 * keeps the bar at four real destinations plus More instead of six cramped
 * slots. Saved preferences in D1 still win over this default once you
 * customise.
 */
export const DEFAULT_PINNED = ['/', '/projections', '/expenses', '/networth'];

export const ROUTE_TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/projections': 'Projections',
  '/scenarios': 'Projections',
  '/expenses': 'Expenses',
  '/funding': 'Funding',
  '/funding/allocation': 'Funding',
  '/funding/settings': 'Funding',
  '/networth': 'Net Worth',
  '/settings': 'Settings',
};
